/* eslint-disable no-console*/
const Warning = message => console.warn(message);

export {Warning};
